import { ADD_SESSION, UPDATE_SUPPLIER, UPDATE_SUPPLIER_LIST, UPDATE_SUPPLIER_MAP } from './types';
import { POST_API } from './../middlewares/form';
import { MAIN_API_HOST } from './../commons/backend/api-config';
import { getDentalCorpBackend } from '../commons/backend/dentalCorpBackendProxy';
import { setCookie, USER_TYPES } from '../commons/utils';
import { setBaseUrlDependingOnUserTypes } from './commonActions';
const dentalCorpBackend = getDentalCorpBackend();

const loginSuccess = (response) => ({
	type: ADD_SESSION,
	payload: response,
});

export const loginUser = (userCredentials) => ({
	[POST_API]: {
		endpoint: `${MAIN_API_HOST}/user/login`,
		types: [],
		payload: {
			username: userCredentials.username,
			password: userCredentials.password,
		},
		onSuccess: async (response, state, dispatch) => {
			const sessionToken = response.response['x-dentalcorp-sessiontoken'];
			setCookie('session-token', sessionToken, 1);

			dispatch(
				loginSuccess({
					session_token: sessionToken,
					user_type: response.response['user_type'] || [],
					group_id: response.response['group_id'] || '',
					seller_portal_config: response.response['seller_portal_config'] || {},
					email: response.response['email'] || '',
				})
			);

			let suppliers = [];
			if ((response?.response?.user_type || []).includes(USER_TYPES.SELLER_ADMIN)) {
				response = await dentalCorpBackend.getAllSuppliers(sessionToken, dispatch);
				if (response !== null && response !== undefined) {
					suppliers = response.response || [];
				}
			}else{
				suppliers = response?.response?.supplier_aliases || [];
			}

			let supplierMap = {};
			response = await dentalCorpBackend.getSupplierMap(sessionToken, { suppliers }, dispatch);
			if (response !== null && response !== undefined) {
				supplierMap = response.response;
			}

			dispatch({ type: UPDATE_SUPPLIER_MAP, payload: supplierMap });
			dispatch({ type: UPDATE_SUPPLIER_LIST, payload: suppliers });
			dispatch({ type: UPDATE_SUPPLIER, payload: suppliers?.[0] || '' });
		},
	},
});
